import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  Button,
  FormLabel,
  Typography,
  Container,
} from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";
import KmFormPreviewTable from "src/components/common/KmFormPreviewTable";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import UserAndDate from "src/components/common/UserAndDate";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import {
  apiEndpoints,
  apiDownloadFileData
} from "src/utils/api/api";
import fileDownload from "js-file-download";

const useStyles = makeStyles((theme) => ({
  root: {},
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(2),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  paddingpaper: {
    padding: theme.spacing(1),
    "& > ol, & > ul": {
      marginLeft: theme.spacing(4),
    },
  },
  paddingtopbottom: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  margintop: {
    marginTop: theme.spacing(1),
  },
  toolbarLeftButton: {
    marginRight: theme.spacing(1),
  }
}));

const RowButtons = (row, customHandlers, ...rest) => {
  return (
    <Box>
      {row.attendanceStatus ? (
        <Tooltip title="Anuluj potwierdzenie">
          <IconButton
            aria-label="anuluj potwierdzenie"
            onClick={() => customHandlers.cancelAttendanceHandler(row)}
          >
            <CancelIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
    </Box>
  );
};

const summaryCols = [
  {
    id: "lp",
    label: "L.p.",
    isLp: true,
    isEditable: false,
    sortable: false,
    width: "5%",
  },
  {
    id: "confirmation",
    label: "Potwierdzenie",
    fieldName: "name",
    isEditable: false,
    sortable: true,
    dataType: 2,
    dataLabels: {
      participation: "Udział potwierdzony",
      no_participation: "Brak udziału potwierdzony",
      cancel: "Potwierdzenie anulowane",
    },
    width: "85%",
  },
  {
    id: "confirmationsCount",
    label: "Liczba użytkoników",
    fieldName: "confirmationsCount",
    isEditable: false,
    sortable: true,
    width: "10%",
  },
];

const Form = ({
  committeeAttendance,
  entryId,
  onCancelAttendance,
  ...rest
}) => {
  const classes = useStyles();
  const [canceledAttendance, setCanceledAttendance] = useState(null);
  const [dialogCancelOpen, setCancelOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    return () => {};
  }, [committeeAttendance]);

  const cancelAttendanceHandler = (row) => {
    setCanceledAttendance(row);
    handleClickCancelAttendanceOpen(row);
  };

  const usersCols = [
    {
      id: "lp",
      label: "L.p.",
      lp: true,
      isEditable: false,
      sortable: false,
      width: "3%",
    },
    {
      id: "username",
      label: "Nazwa użytkownika",
      fieldName: "username",
      isEditable: false,
      sortable: true,
      width: "9%",
    },
    {
      id: "userFirstName",
      label: "Imię",
      fieldName: "userFirstName",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userLastName",
      label: "Nazwisko",
      fieldName: "userLastName",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userInstitution",
      label: "Instytucja",
      fieldName: "userInstitution",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userFunction",
      label: "Funkcja",
      fieldName: "userFunction",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "attendanceStatus",
      label: "Potwierdzenie",
      fieldName: "attendanceStatus",
      isEditable: false,
      sortable: true,
      dataType: 2,
      dataLabels: {
        participation: "Udział potwierdzony",
        no_participation: "Brak udziału potwierdzony",
        cancel: "Potwierdzenie anulowane",
      },
      width: "22%",
    },
    {
      id: "createdAt",
      label: "Kiedy wygenerowano",
      fieldName: "createdAt",
      isEditable: false,
      sortable: true,
      width: "10%",
    },

    {
      id: "createdBy",
      label: "Kto wygenerował",
      fieldName: "createdBy",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: { cancelAttendanceHandler },
      component: RowButtons,
      width: "5%",
    },
  ];

  const handleClickCancelAttendanceOpen = () => {
    setCancelOpen(true);
  };

  const handleCancelAttendanceDialogClose = () => {
    setCancelOpen(false);
  };

  const handleCancelAttendance = () => {
    setCancelOpen(false);

    onCancelAttendance(canceledAttendance);
  };

  const handleExport = () => {
    apiDownloadFileData(`${apiEndpoints.getCommitteeAttendancesExcel.path}${entryId}`, true).then(
      (result) => {
        fileDownload(result, "Potwierdzenia uczestnictwa w posiedzeniu.xls");
      }
    );
  };

  return (
    <Card className={clsx(classes.root)} {...rest}>
        <Container component="main" maxWidth={false}>
          <Grid container className={classes.paddingtop}>
            <Grid item xs={12} elevation={2}>
              {committeeAttendance ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  <Typography>{committeeAttendance.structNodeName}</Typography>
                </FormControl>
              ) : (
                <Skeleton />
              )}

              {committeeAttendance ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Status
                  </FormLabel>
                  <Typography>
                    {committeeAttendance.attendanceCheckingActive
                      ? "Zbieranie potwierdzeń aktywne"
                      : "Zbieranie potwierdzeń nieaktywne"}
                  </Typography>
                </FormControl>
              ) : (
                <Skeleton />
              )}
              {committeeAttendance ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sm={6}>
                      <FormLabel
                        className={classes.paddingBottom}
                        component="label"
                      >
                        Kto i kiedy rozpoczął potwierdzenia
                      </FormLabel>
                      <UserAndDate
                        variant="body1"
                        username={committeeAttendance.startedBy}
                        date={committeeAttendance.startedAt}
                        separator=", "
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} sm={6}>
                      <FormLabel
                        className={classes.paddingBottom}
                        component="label"
                      >
                        Kto i kiedy zakończył potwierdzenia
                      </FormLabel>
                      <UserAndDate
                        variant="body1"
                        username={committeeAttendance.finishedBy}
                        date={committeeAttendance.finishedAt}
                        separator=", "
                      />
                    </Grid>
                  </Grid>
                </FormControl>
              ) : (
                <Skeleton />
              )}
              {committeeAttendance ? (
                <Box className={classes.paddingtopbottom}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Podsumowanie potwierdzeń
                  </FormLabel>
                  <KmFormPreviewTable
                    columns={summaryCols}
                    rows={committeeAttendance.confirmSummary}
                  />
                </Box>
              ) : (
                <Skeleton />
              )}
              {committeeAttendance ? (
                <Box className={classes.paddingtopbottom}>
                  <Box display="flex" justifyContent="flex-end">
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.toolbarLeftButton}
                      component={RouterLink}
                      to={`/potwierdzeniaudzialu/edycjapotwierdzenia/${committeeAttendance.structNodeId}`}
                    >
                      Potwierdź w imieniu użytkownika
                    </Button>
                    <Button
                      color="secondary"
                      variant="contained"
                      onClick={handleExport}
                      className={classes.toolbarLeftButton}
                    >
                      Eksport potwierdzeń
                    </Button>
                  </Box>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Potwierdzenia użytkowników
                  </FormLabel>
                  <KmFilteredTable
                    className={classes.paddingtop}
                    markable={false}
                    headCells={usersCols}
                    rows={committeeAttendance.committeeAttendances}
                  />
                </Box>
              ) : (
                <Skeleton />
              )}

              <Box className={classes.paddingtopbottom}>
                <Button
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={`/dokumenty/${entryId}`}
                >
                  Zamknij
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      <Dialog
        fullScreen={fullScreen}
        open={dialogCancelOpen}
        onClose={handleCancelAttendanceDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Anulowanie potwierdzenia użytkownika"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography paragraph>
              Czy na na pewno chcesz anulować potwierdzenie użytkownika "
              {canceledAttendance ? canceledAttendance.username : "-"}"?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleCancelAttendanceDialogClose}
            color="primary"
          >
            Nie
          </Button>
          <Button onClick={handleCancelAttendance} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default Form;
